export var PartnerNameUrlEnum;
(function (PartnerNameUrlEnum) {
    PartnerNameUrlEnum["pingo"] = "Pingo";
    PartnerNameUrlEnum["logicLike"] = "LogicLike";
    PartnerNameUrlEnum["kion"] = "Kion";
    PartnerNameUrlEnum["music"] = "Music";
    PartnerNameUrlEnum["leoni"] = "Leoni";
})(PartnerNameUrlEnum || (PartnerNameUrlEnum = {}));
